function dismissTopBar() {
    const topBar = document.getElementById('topBar');
    if (!topBar) return;

    topBar.animate(
        [
            { maxHeight: topBar.scrollHeight + 'px', opacity: '1' },
            { maxHeight: '0', opacity: '0' }
        ],
        { duration: 300, easing: 'ease-out', fill: 'forwards' }
    ).onfinish = () => {
        topBar.remove();
        document.cookie = 'topbar_dismissed=1; path=/; SameSite=Lax; max-age=' + (60 * 60 * 24 * 365);
    };
}

document.getElementById('topBarClose')?.addEventListener('click', dismissTopBar);

let lastScrollTop = 0;
const scrollDelta = 150;

function showStickyNav() {
    const scrollTop = $(window).scrollTop();
    const navbarHeight = $('header').outerHeight();

    if (scrollTop === 0) {
        $('header').removeClass('sticky');
        $('main').css('padding-top', 0);
        lastScrollTop = scrollTop;
        return;
    }

    // Make sure they scroll more than delta
    if (Math.abs(lastScrollTop - scrollTop) <= scrollDelta) {
        return;
    }

    // If they scrolled down and are past the navbar, add class sticky.
    if (scrollTop > lastScrollTop && scrollTop > navbarHeight) {
        // Scroll Down
        $('header').removeClass('sticky');
        $('main').css('padding-top', 0);
    } else {
        // Scroll Up
        if (scrollTop + $(window).height() < $(document).height() && scrollTop < lastScrollTop) {
            $('header').addClass('sticky');
            $('main').css('padding-top', navbarHeight);
        }
    }

    lastScrollTop = scrollTop;
}

$(window).on('scroll', function() {
    const isCheckoutPage = $('.checkout-master').length > 0;
    if (!isCheckoutPage) {
        showStickyNav();
    }
});
